import { AbstractModel } from '../base';
import { IAttachment, IAttachmentData } from './attachment.types';

export abstract class AbstractAttachment extends AbstractModel
  implements IAttachment {
  readonly id?: number | undefined;
  readonly file: string | File;
  readonly filename: string = '';

  protected constructor(data: IAttachmentData) {
    super();

    const requiredFields: (keyof IAttachmentData)[] = ['file'];
    this.validate(data, requiredFields);

    if (data.id) {
      this.id = data.id;
    }

    this.file = data.file!;

    if (data.filename) {
      this.filename = data.filename;
    }
  }

  abstract toString(): string;
}
